webpackJsonpUpdateBris([88],{

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ProductCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'ProductCarousel';
var CLS = 'productCarousel';
var BLK = '.' + CLS + '-';
var SLIDE_TO_SHOW = 4;
var CLS_IS_INITED = 'is-initialized';

var ProductCarousel = exports.ProductCarousel = function () {
	function ProductCarousel(el) {
		_classCallCheck(this, ProductCarousel);

		this.el = el;
		this.$el = $(el);
		this.$slider = this.$el.find('.' + CLS + '-slider');
		this.$sliderWrap = this.$el.find('.' + CLS + '-sliderWrap');
		this.$btnNext = this.$el.find('.' + CLS + '-btnWrapNext');
		this.$btnPrev = this.$el.find('.' + CLS + '-btnWrapPrev');

		this.slidesToShow = this.$el.data('slidesToShow');
		if (this.slidesToShow && !isNaN(this.slidesToShow)) {
			this.slidesToShow = parseInt(this.slidesToShow);
		}

		this.initSwiper();
	}

	_createClass(ProductCarousel, [{
		key: 'initSwiper',
		value: function initSwiper() {
			var _breakpoints,
			    _this = this;

			// from mobile to desktop
			var slidesToShow = this.slidesToShow || SLIDE_TO_SHOW;
			var slidesToShowLG = slidesToShow - 1 || 1;

			var swiper = new Swiper(this.$sliderWrap[0], {
				init: false,
				slidesPerView: 2.25,
				spaceBetween: 16,
				freeMode: true,
				mousewheel: true,
				navigation: {
					nextEl: this.$el.find('.swiper-button-next')[0],
					prevEl: this.$el.find('.swiper-button-prev')[0]
				},
				scrollbar: this.isMini ? false : {
					el: this.$sliderWrap.find('.swiper-scrollbar')[0],
					draggable: true
				},
				breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, utils.BREAKPOINT.MD, {
					slidesPerView: 3
				}), _defineProperty(_breakpoints, utils.BREAKPOINT.LG, {
					slidesPerView: slidesToShowLG > 4 ? 4 : slidesToShowLG // force to have 4 slides
				}), _defineProperty(_breakpoints, utils.BREAKPOINT.XL, {
					slidesPerView: slidesToShow > 5 ? 5 : slidesToShow // force to have 5 slides
				}), _breakpoints)
			});

			swiper.on('init', function () {
				_this.$el.addClass(CLS_IS_INITED);
			});

			swiper.init();
		}
	}]);

	return ProductCarousel;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.blk-product-carousel-chunk.js